"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { useOpenEventSearch } from "~/hooks/events/useOpenEventSearch";
import type { DriverEventDay } from "~/server/api/routers/events";
import { VehicleSizePrompt } from "./VehicleSizePrompt";
type LauncherRenderProps = {
  openEventSearch: (day: DriverEventDay) => void;
  busyKey: string | null;
};

/**
 * Owns the event → search hand-off for a list of event days, and renders the
 * size prompt that hand-off occasionally needs.
 *
 * A render-prop wrapper rather than a hook call in each surface so the prompt
 * has exactly one mount per list: the nearby strip and the `/events` list both
 * render many rows, and a prompt per row would be many dialogs and many copies
 * of the vehicle query. Both surfaces stay presentational.
 */
export function EventSearchLauncher(t0) {
  const $ = _c(12);
  const {
    children
  } = t0;
  const {
    openEventSearch,
    busyKey,
    askingFor,
    confirmVehicleSize,
    dismissVehiclePrompt
  } = useOpenEventSearch();
  let t1;
  if ($[0] !== busyKey || $[1] !== children || $[2] !== openEventSearch) {
    t1 = children({
      openEventSearch,
      busyKey
    });
    $[0] = busyKey;
    $[1] = children;
    $[2] = openEventSearch;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = askingFor !== null;
  const t3 = askingFor?.event.venueName ?? askingFor?.event.name;
  let t4;
  if ($[4] !== confirmVehicleSize || $[5] !== dismissVehiclePrompt || $[6] !== t2 || $[7] !== t3) {
    t4 = <VehicleSizePrompt open={t2} eventName={t3} onSelect={confirmVehicleSize} onDismiss={dismissVehiclePrompt} />;
    $[4] = confirmVehicleSize;
    $[5] = dismissVehiclePrompt;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <>{t1}{t4}</>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}